
// @ts-nocheck

import { useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { NewReferencesOfAccount } from "../../../../Utils/AllPagesQuriesAndMutations";
import LoadTable from "../../LoadTable/LoadTable";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";
import "./Reference.scss";
import { ConvertDateValues } from "../../../custom_hooks/ChangeDateValues";
import { useRecoilState } from "recoil";
import { AtomstateCallback } from "../../VirtualTable/Tablefunctions";
import { IsoToDateWithoutTime } from "../../../../CommonFunction/IsoDateTime";
interface TypeofProps {
  modalOpen: boolean;
  OpenModal: () => void;
  Account_ID: string;
  handleAginstRef: () => void;
  query: any;
  newRefId?: any[]
}
interface newRefTyeo {
  _id: string;
  Unique_Id: string;
  Type: string;
  RefDate: string;
  Amount: number;
  TransactionType: string;
  Particular: string;
  createdAt: string;
  updatedAt: string;
}

export const NewRefModal = ({ modalOpen, OpenModal, Account_ID, handleAginstRef, query, newRefId }: TypeofProps) => {
  const [formdata, setformdata] = useState<newRefTyeo[]>();

  const Form_Key = "New_Refrence";
  const NewReferenceData = useSelector((store: any) => store.UniqueTableReducer);
  const {
    data: newRefData,
    loading,
    error,
  } = useQuery(NewReferencesOfAccount, {
    variables: {
      Account_Id: Account_ID,
      newRefId: newRefId && newRefId[0]?._id
    },
    fetchPolicy: "network-only"
  });

  useEffect(() => {
   
    if (newRefData?.get_All_New_Refrence_Of_Account_Id?.References) {
      let Data = newRefData?.get_All_New_Refrence_Of_Account_Id?.References.map((el) => {
        return { ...el, RefDate: el.RefDate ? IsoToDateWithoutTime(el.RefDate) : "" }
      })
   
      setformdata(Data);
    }
  }, [newRefData]);


  const [toggle, setToggle] = useState<boolean>(modalOpen);
  const Closeformfunction = () => {
    setToggle(false);
    OpenModal();
    handleAginstRef();
  };
  // console.log(NewReferenceData?.New_Ref_Modal?.Selected_Row, newRefId)
  // let selectedRow = newRefId
  // || NewReferenceData?.New_Ref_Modal?.Selected_Row?._id
  // console.log(selectedRow)
  return (
    <>
      <Reactportal
        open={toggle}
        onClose={Closeformfunction}
        TypeOfPortal={"Reference"}
        TypeOfId={"Account Id :"}
        UserRightsPortal={false}
      >
        <div className="newRefContainer">
          {!formdata?.length ? (
            <p className="DataNotAvailable">Data not Available</p>
          ) : (
            <div>
              <LoadTable
                title="New_Ref_Modal"
                data={formdata}
                loading={loading}
                error={error}
                selectedRows={newRefId}
                ModalTable={true}
              />
            </div>
          )}
        </div>

        <PortalFooter
          renderContent={() => <></>}
          disabled={false}
          submitform={Closeformfunction}
          submitType={"Close"}
          TypeOfPortal={"Bill By Bill"}
          disableupload={false}
        />
      </Reactportal>
    </>
  );
};
